import React from 'react';
import { Card, CardMedia, CardContent } from '@mui/material';
import Quantite from '../forms/Quantite';

export default function CardUniteTravail({ uniteTravail, val }) {

	return (
		<Card>
			<CardContent align="center" sx={{ fontSize: 18, color: '#FFFFFF', backgroundColor: '#004AFE' }}>
				{uniteTravail.name}
			</CardContent>
			<CardMedia
				component="img"
				image={process.env.REACT_APP_PATH_IMAGES + '/' + uniteTravail.picturePath}
				alt={uniteTravail.pictureDescription} />
			<CardContent align="center">
				<Quantite id={uniteTravail.workUnitKey} val={val} min={uniteTravail.quantiteMin} max={uniteTravail.quantiteMax} />
			</CardContent>
		</Card>
	);
}